"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("../button");
var _icon = _interopRequireDefault(require("../icon"));
var _StyledTemplatePopup = require("./StyledTemplatePopup.style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var EditMenu = function EditMenu(_ref) {
  var onClose = _ref.onClose,
    onEdit = _ref.onEdit,
    onDelete = _ref.onDelete;
  return /*#__PURE__*/_react["default"].createElement(_StyledTemplatePopup.StyledEditMenu, null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    id: "media-creator-close",
    icon: "ion-close-circled",
    size: 18,
    className: "input-clear-icon",
    "aria-label": "Close pop-up",
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "menu-list"
  }, /*#__PURE__*/_react["default"].createElement(_button.Button, {
    type: "link",
    action: onEdit,
    className: "edit-menu-item"
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    icon: "ion-edit",
    size: 20,
    "aria-label": "Edit link"
  }), "Edit link"), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    type: "link",
    action: onDelete,
    className: "delete-menu-item"
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    icon: "ion-trash-b",
    size: 20,
    "aria-label": "Delete link",
    className: "delete-icon"
  }), "Delete link")));
};
EditMenu.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  onEdit: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = EditMenu;